module.exports = __webpack_public_path__ + "media/customizations/smartlife/logo-00476746b75e0b7432e17a5417697d44.png";